export default __webpack_public_path__ + "static/media/fido.e9a1bf54.png";